"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var normalizer_1 = __importDefault(require("./cancel-order/normalizer"));
var normalizer_2 = __importDefault(require("./catalog/normalizer"));
var normalizer_3 = __importDefault(require("./check-address/normalizer"));
var normalizer_4 = __importDefault(require("./combinations/normalizer"));
var normalizer_5 = __importDefault(require("./compute-cart/normalizer"));
var normalizer_6 = __importDefault(require("./coupons/normalizer"));
var normalizer_7 = __importDefault(require("./info/normalizer"));
var normalizer_8 = __importDefault(require("./newsletter/normalizer"));
var normalizer_9 = __importDefault(require("./order-status/normalizer"));
var normalizer_10 = __importDefault(require("./purchase/normalizer"));
var normalizer_11 = __importDefault(require("./promo-code/normalizer"));
var normalizer_12 = __importDefault(require("./referral/normalizer"));
var normalizer_13 = __importDefault(require("./tax/normalizer"));
exports.default = {
    cancelOrder: normalizer_1.default,
    catalog: normalizer_2.default,
    checkAddress: normalizer_3.default,
    combinations: normalizer_4.default,
    computeCart: normalizer_5.default,
    coupons: normalizer_6.default,
    info: normalizer_7.default,
    newsletter: normalizer_8.default,
    orderStatus: normalizer_9.default,
    promoCode: normalizer_11.default,
    purchase: normalizer_10.default,
    referral: normalizer_12.default,
    tax: normalizer_13.default,
};
